export enum Flipper {
  connectOrders = 'connect_orders',
  rescheduleAndCancelConnectOrder = 'reschedule_and_cancel_connect_order',
  operationalDashboard = 'connect_operational_dashboard',
  createConnectOrder = 'create_connect_order',
  displayStageOrderItemWeights = 'connect_stage_order_item_weights',
  orderCreationErrorModal = 'connect_order_creation_errors_modal',
  tipAmountUnits = ' connect_tip_amount_units',
  cacheFilters = 'connect_order_table_cached_filters',
  orderCreationBagLabel = 'connect_order_creation_bag_label',
  etaDeliverySlots = 'connect_enable_eta_delivery_slots',
  orderCancellationReason = 'connect_order_cancellation_reason',
  LMDDashboardEnhancements = 'rt_esi_lmd_dashboard_enhancements',
}
